import React, { useContext, useState, useEffect, useReducer, useRef } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import Util from '../../Util';
import SideNav from '../patient/shared/SideNav';
import Breadcrumb from '../shared/Breadcrumb';
import { SignalRContext } from '../../contexts/SignalRContext';
import alertify from "alertifyjs";
import axios from 'axios';
import { apiRoutes } from '../../AppSettings';
import Spinner from '../shared/Spinner';


const MESSAGE_SENT = "SENT";
const MESSAGE_RECEIVE = "RECEIVE";
const SET_USERS_MESSAGES = "SET_USERS_MESSAGES";
const SET_UNREAD_MESSAGES = "SET_UNREAD_MESSAGES";
const UserActiveClassName = "media read-chat active";
const IdleClassName = "media";

const initialValue = {
	messages: [],
	allUnreadMessages: [],
	userWithMessages: []
}

const reducer = (state, action) => {
	switch (action.type) {
		case MESSAGE_SENT:
			return { ...state, messages: action.messages };
		case MESSAGE_RECEIVE:
			return { ...state, messages: action.messages };
		case SET_UNREAD_MESSAGES:
			return { ...state, allUnreadMessages: action.allUnreadMessages };
		case SET_USERS_MESSAGES:
			return { ...state, userWithMessages: action.userWithMessages };
		default:
			return state;
	}
}

const ChatApp = (props) => {
	const [activeReceiver, setReceiver] = useState({});

	const { userState } = useContext(AuthContext);
	const { signalRConnection, join } = useContext(SignalRContext);
	const [caller, setCaller] = useState(userState.user);
	const [message, setMessage] = useState('');
	const el = useRef(null);
	const [showSpinner, setShowSpinner] = useState(false);

	const isPatient = userState.userType.toLowerCase() === "patient";

	const [state, dispature] = useReducer(reducer, initialValue);

	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': 'bearer ' + userState.token
		}
	};



	useEffect(() => {
		el.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
	});

	useEffect(() => {
		setShowSpinner(true);
		axios.get(apiRoutes.GetMessages + caller.userId + '/' + userState.userType, options)
			.then((response) => {
				if (response.status === 200) {
					const data = response.data;
					console.log(data)

					if (data != undefined && data.length > 0) {
						data.forEach(item => {
							state.allUnreadMessages.push(item);
						});
						dispature({ type: SET_UNREAD_MESSAGES, allUnreadMessages: state.allUnreadMessages });

						signalRConnection.invoke("SendUserListUpdate").catch((err) => {
							console.log(err);
						});
					} else {
						if (props.location.state != undefined) {
							let userWithMessage = {
								id: Util.getRandomNumber(),
								user: JSON.parse(props.location.state.receiver),
								messages: [],
								status: 'online',
								className: UserActiveClassName,
								unreadMessageCount: 0
							}

							state.userWithMessages.push(userWithMessage);

							setReceiver(userWithMessage);
						}
					}
				}
			}, (error) => {
				console.log(error);
			});

		setTimeout(() => {
			console.log('here')
			if (signalRConnection.connectionState == 0) {
				console.log('here else 1')

				console.log(signalRConnection);
				signalRConnection.start().then(() => {
					console.log('call on start')
				

				}).catch(err =>
					console.log(err)
				);


			}
			else {
				setTimeout(() => join(userState.user.userName), 1000);
			}
		}, 1000);


		signalRConnection.on('receiveMessage', (callingUser, message) => {
			console.log('SignalR: incoming message from: ' + JSON.stringify(callingUser));
			console.log('message: ' + JSON.stringify(message));

			message.isSent = false;

			state.userWithMessages.forEach(element => {
				if (element.user.emailAddress === callingUser.userName) {
					if (!messageExists(element, message)) {
						element.messages.push(message);
						playSound();
					}
				}
			});
			dispature({ type: SET_USERS_MESSAGES, userWithMessages: state.userWithMessages });

			console.log(state.messages);
			//	dispature({type: MESSAGE_RECEIVE, messages: state.messages});
		});


		signalRConnection.on('updateUserList', (userList) => {
			setShowSpinner(false);
			console.log('SignalR: called updateUserList' + JSON.stringify(userList));
			var isCallerinList = false;
			var isReceiverinList = false;

			userList.forEach(item => {
				if (item.userName == caller.userName) {
					isCallerinList = true;
				}
				if (props.location.state != undefined) {
					if (item.userName == JSON.parse(props.location.state.receiver).emailAddress) {
						isReceiverinList = true;
					}
				}
			});

			let tempEmail = '';

			const callerMessages = state.allUnreadMessages.filter(m => {
				return m.user.emailAddress == caller.userName;
			})

			state.allUnreadMessages.filter(m => {
				return m.user.emailAddress != caller.userName;
			}).forEach(m => {
				if (m.user != undefined && m.user.emailAddress != tempEmail) {
					tempEmail = m.user.emailAddress;

					let userWithMessages = {
						id: Util.getRandomNumber(),
						user: m.user,
						messages: [],
						status: '',
						className: IdleClassName,
						unreadMessageCount: 0
					}

					var isReceiverinList = false;
					userList.forEach(item => {
						if (item.userName == tempEmail) {
							isReceiverinList = true;
						}
					});

					if (isReceiverinList) {
						userWithMessages.status = 'online';
					}
					else {
						userWithMessages.status = 'offline';
					}

					state.allUnreadMessages.forEach(message => {
						if (message.user.emailAddress == tempEmail) {
							userWithMessages.messages.push(message);
						}
					})

					if (callerMessages.length > 0) {
						callerMessages.filter(m => {
							return m.receiver == tempEmail
						}).forEach(m => {
							userWithMessages.messages.push(m);
						});
					}

					if (userWithMessages.messages.length > 0) {
						let sortedMessage = userWithMessages.messages.sort((a, b) => (new Date(b.date)) - (new Date(a.date)))
						userWithMessages.latestMessage = sortedMessage.slice(0, 1)[0];

						var unreadMessages = userWithMessages.messages.filter(message => {
							return message.unread;
						})

						userWithMessages.unreadMessageCount = unreadMessages.length;

						userWithMessages.messages = sortedMessage.reverse();
					}
					else {
						userWithMessages.latestMessage = {};
						userWithMessages.unreadMessageCount = 0;
					}

					var item = state.userWithMessages.filter(userMessage => {
						return userMessage.user.emailAddress == tempEmail
					})

					if (item == undefined || item.length == 0) {
						state.userWithMessages.push(userWithMessages);
					}
				}
			})

			if (state.userWithMessages.length > 0) {
				console.log(state.userWithMessages);

				if (props.location.state != undefined) {
					var item = state.userWithMessages.filter(userMessage => {
						return userMessage.user.emailAddress == JSON.parse(props.location.state.receiver).emailAddress
					})

					if (item == undefined || item.length == 0) {
						let userWithMessages = {
							id: Util.getRandomNumber(),
							user: JSON.parse(props.location.state.receiver),
							messages: [],
							status: isReceiverinList ? 'online' : 'offline',
							className: UserActiveClassName,
							unreadMessageCount: 0
						}

						state.userWithMessages.push(userWithMessages);

						setReceiver(userWithMessages);
					} else {
						console.log(item[0]);
						item[0].status = isReceiverinList ? 'online' : 'offline';
						item[0].className = UserActiveClassName;
						setReceiver(item[0]);
					}
				}
				else {
					state.userWithMessages[0].className = UserActiveClassName;
					setReceiver(state.userWithMessages[0]);
				}


				dispature({ type: SET_USERS_MESSAGES, userWithMessages: state.userWithMessages });
			}
			else {
				console.log('here 22')
			}

			if (!isCallerinList) {
				join(caller.userName);
			}
		});

	}, []);



	function messageExists(element, message) {
		return element.messages.some(function (el) {
			return el.id === message.id;
		});
	}

	const sendMessage = e => {
		if (message != undefined && message != '') {
			var newMessage = {
				id: Util.getRandomNumber(),
				sender: caller.userName,
				receiver: activeReceiver.user.emailAddress,
				message: message,
				date: null,
				isSent: true,
				time: Util.getTimeAMPM(),
				attachment: []
			};


			//	activeReceiver.messages.push(newMessage);
			//	setReceiver(activeReceiver);


			state.userWithMessages.forEach(element => {
				if (element.id === activeReceiver.id) {
					element.messages.push(newMessage);
				}
			});
			dispature({ type: SET_USERS_MESSAGES, userWithMessages: state.userWithMessages });

			dispature({ type: MESSAGE_SENT, messages: state.messages });
			signalRConnection.invoke('sendMessage', { "userName": activeReceiver.user.emailAddress }, { "userName": caller.userName }, newMessage);
			setMessage('');

		}
		else {
			alertify.error('Please type message before send');
		}
	}

	const handleClickonUser = (e, id) => {
		state.userWithMessages.forEach(element => {
			if (element.id === id) {
				element.className = UserActiveClassName;
				setReceiver(element);

				element.messages.forEach(message => {
					if (message.unread)
						message.unread = false;
				})

				element.unreadMessageCount = 0;

				MarkMessagesAsRead(element.messages);
			}
			else {
				element.className = IdleClassName;
			}
		});
		dispature({ type: SET_USERS_MESSAGES, userWithMessages: state.userWithMessages });
	}

	const MarkMessagesAsRead = (messages) => {
		axios.post(apiRoutes.MarkMessagesAsRead, JSON.stringify(messages), options)
			.then((response) => {
			}, (error) => {
				console.log(error);
			});
	}

	const handleKeypress = e => {
		//it triggers by pressing the enter key
		if (e.charCode === 13) {
			sendMessage();
		}
	};

	const playSound = () => {
		var aSound = document.createElement('audio');
		aSound.setAttribute('src', 'assets/ping.ogg');
		aSound.play();
	}

	return (
		<div>
			<Breadcrumb title="Chat" />
			<div className="content">
				<Spinner show={showSpinner} />
				<div className="container-fluid">
					<div className="row">
						<div className="col-xl-12">
							<div className="chat-window">
								<div className="chat-cont-left">
									<div className="chat-header">
										<span>Chats</span>
										<a href="javascript:void(0)" className="chat-compose">
											<i className="material-icons">control_point</i>
										</a>
									</div>
									<div className="chat-users-list">
										<div className="chat-scroll">
											{
												state.userWithMessages != undefined &&
												state.userWithMessages.map(item => (
													<a key={item.id} className={item.className} onClick={(e) => handleClickonUser(e, item.id)}>
														<div className="media-img-wrap">
															<div className={item.status == 'online' ? 'avatar avatar-online' : 'avatar avatar-offline'} >
																<img src={Util.loadImage(item.user.profileImage)} alt="User Image" className="avatar-img rounded-circle" />
															</div>
														</div>
														<div className="media-body">
															<div>
																<div className="user-name">{item.user.firstName} {item.user.lastName}</div>
																<div className="user-last-chat">{item.latestMessage != undefined ? item.latestMessage.message : 'Hi'}</div>
															</div>
															<div>
																<div className="last-chat-time block">{item.latestMessage != undefined && Util.getDateDifffromToDay(item.latestMessage.date)}</div>
																<div className="badge badge-success badge-pill">{item.unreadMessageCount != undefined && item.unreadMessageCount != 0 && item.unreadMessageCount}</div>
															</div>
														</div>
													</a>
												))
											}
										</div>
									</div>
								</div>
								<div className="chat-cont-right">
									<div className="chat-header">
										<a id="back_user_list" href="javascript:void(0)" className="back-user-list">
											<i className="material-icons">chevron_left</i>
										</a>
										<div className="media">
											<div className="media-img-wrap">
												<div className={activeReceiver.status == 'online' ? 'avatar avatar-online' : 'avatar avatar-offline'} >
													<img src={Util.loadImage(activeReceiver.user != undefined && activeReceiver.user.profileImage)} alt="User Image" className="avatar-img rounded-circle" />
												</div>
											</div>
											<div className="media-body">
												<div className="user-name"> {isPatient ? 'Dr.' : ''} {activeReceiver.user != undefined && activeReceiver.user.firstName} {activeReceiver.user != undefined && activeReceiver.user.lastName}</div>
												<div className="user-status">online</div>
											</div>
										</div>
										<div className="chat-options">
											<a href="javascript:void(0)" data-toggle="modal" data-target="#voice_call">
												<i className="material-icons">local_phone</i>
											</a>
											<a href="javascript:void(0)" data-toggle="modal" data-target="#video_call">
												<i className="material-icons">videocam</i>
											</a>
											<a href="javascript:void(0)">
												<i className="material-icons">more_vert</i>
											</a>
										</div>
									</div>
									<div className="chat-body">
										<div className="chat-scroll">
											<ul className="list-unstyled">
												{
													activeReceiver.messages != undefined &&
													activeReceiver.messages.map(msg => (
														msg.isSent ?
															<li key={msg.id} className="media sent">
																<div className="media-body">
																	<div className="msg-box">
																		<div>
																			<p>{msg.message}</p>
																			<ul className="chat-msg-info">
																				<li>
																					<div className="chat-time">
																						<span>{msg.time}</span>
																					</div>
																				</li>
																			</ul>
																		</div>
																	</div>
																</div>
															</li>
															:
															<li key={msg.id} className="media received">
																<div className="avatar">
																	<img src={Util.loadImage(activeReceiver.user.profileImage != undefined && activeReceiver.user.profileImage)} alt="User Image" className="avatar-img rounded-circle" />
																</div>
																<div className="media-body">
																	{
																		msg.message.length > 0 &&
																		<div className="msg-box">
																			<div>
																				<p>{msg.message}</p>
																				<ul className="chat-msg-info">
																					<li>
																						<div className="chat-time">
																							<span>{msg.time}</span>
																						</div>
																					</li>
																				</ul>
																			</div>
																		</div>
																	}
																	{
																		msg.attachment != undefined &&
																		msg.attachment.length > 0 &&
																		<div className="msg-box">
																			<div>
																				<div className="chat-msg-attachments">
																					{
																						msg.attachment.map(a => (
																							<div key={a} className="chat-attachment">
																								<img src="assets/img/img-02.jpg" alt="Attachment" />
																								<div className="chat-attach-caption">{a}</div>
																								<a href="" className="chat-attach-download">
																									<i className="fas fa-download"></i>
																								</a>
																							</div>
																						))
																					}

																				</div>
																				<ul className="chat-msg-info">
																					<li>
																						<div className="chat-time">
																							<span>{msg.time}</span>
																						</div>
																					</li>
																				</ul>
																			</div>
																		</div>
																	}
																</div>
															</li>
													))
												}
												<li id={'el'} ref={el}>

												</li>
											</ul>
										</div>


									</div>

									{
										activeReceiver.user != undefined &&
										<div className="chat-footer">
											<div className="input-group">
												<div className="input-group-prepend">
													<div className="btn-file btn">
														<i className="fa fa-paperclip"></i>
														<input type="file" />
													</div>
												</div>
												<input type="text" className="input-msg-send form-control" placeholder="Type something" value={message}
													onChange={e => setMessage(e.target.value)}
													onKeyPress={handleKeypress} />
												<div className="input-group-append">
													<button type="button" className="btn msg-send-btn" onClick={e => sendMessage(e)}><i className="fab fa-telegram-plane"></i></button>
												</div>
											</div>
										</div>
									}

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	);
}

export default ChatApp;